const EnumExpressionsText: { [key: string]: string } = Object.freeze({
  LOST: "LOST",
  PAUSE: "PAUSE",
  GREAT: "GREAT",
  REW: "REW",
  FF: "FF",
});

export default EnumExpressionsText;
